import { Company, Lead, ProposalContentType, ProposalFormatType } from "..";
import { LeadConfigurationType } from "./configuration";
import { Customer } from "./customer";
import { OwnerUser } from "./user";

export enum InteriorType {
  BareShell = "Bare Shell",
  Warmshell = "Warm Shell",
  SemiFurnished = "Semi Furnished",
  PreFurnished = "Pre Furnished",
  FullyFurnished = "Fully Furnished",
}

export interface LeadRequirement {
  hasAnyProposalApproved?: boolean;
  _id: string;
  city: string;
  cityDetails?: {
    _id?: string;
    cityName: string;
  };
  microMarkets: string[];
  microMarketDetails?: {
    _id?: string;
    cityId: string;
    cityName: string;
    cityZoneName: string;
  }[];
  preferredLocations?: string[];
  preferredLocationDetails?: {
    _id?: string;
    cityName: string;
    cityLocName: string;
  }[];
  propertyType: string;
  propertyTypeDetails?: {
    propertyTypeKey: string;
    propertyTypeName: string;
  };
  projectType: string;
  projectTypeDetails?: {
    propertyTypeKey: string;
    propertyTypeName: string;
  }[];
  minPrice: number;
  maxPrice: number;
  minArea: number;
  maxArea: number;
  minSeats?: number;
  maxSeats?: number;
  proposalDueBy?: Date;
  earliestMoveInDate: Date;
  lastMoveInDate: Date;
  floorPreferences?: string[];
  floorPreferenceDetails?: {
    _id?: string;
    floorName: string;
  }[];
  preferedProjects?: string[];
  preferedProjectDetails?: {
    _id?: string;
    projectName: string;
  }[];
  preferredDevelopers?: string[];
  preferedDeveloperDetails?: {
    _id?: string;
    developer: string;
  }[];
  constructionStatus?: ConstructionStatus[];
  facilityType?: string;
  interiorType?: InteriorType[];
  carParking?: boolean;
  powerBackup?: boolean;
  grade?: Grade;
  amenities?: string[];
  amenitiyDetails?: {
    _id?: string;
    amenity: string;
  }[];
  leaseExpiry?: Date;
  leadId?: string;
  customerId?: string;
  status?: RequirementStatus;
  parentId?: string;
  isLatest?: boolean;
  projectsCount?: number;
  propertiesCount?: number;
  createdBy?: OwnerUser;
  createdAt?: Date;
  configurationType?: LeadConfigurationType;
  customer?: Customer;
  leadDetails?: Lead;
  salesPerson?: OwnerUser;
  versionNumber?: number;
  versions?: {
    _id: string;
    versionNumber: number;
  }[];
  approvedRequirement?: LeadRequirement[];
  updatedAt?: Date;
  masterRequirementId?: string;
  approvedBy?: OwnerUser;
  approvedAt?: Date;
  rejectedBy?: OwnerUser;
  rejectedAt?: Date;
  haveProposal?: boolean;
  companyId?: string;
  proposalFormatType?: ProposalFormatType;
  proposalContentType?: ProposalContentType;
  forecast?: number;
  certainity?: number;
  weightage?: number;
  specialRequirements?: string;
  facilityTypeDetails?: {
    facilityType: string;
  };
  constructionCompletionDate?: string;
  includeGradeC?: boolean;
  includeLeaseExpiry?: boolean;
  stageCode: RequirementStageCodes;
  stageStatus: string;
  coreRequirementParameters?: string[];
  coreRequirements?: string[];
  companyDetails?: Company;
}

export enum Grade {
  A = "A",
  B = "B",
  C = "C",
}

export enum ConstructionStatus {
  Upcoming = "upcoming",
  ReadyToMove = "readyToMove",
  UnderConstruction = "underConstruction",
  Operational = "operational",
  ContactForAvailaibility = "contactForAvailability",
  LeasedOut = "leasedOut",
  SoldOut = "soldOut",
  NotAvailable = "notAvailaible",
}

export enum RequirementStatus {
  Approved = "approved",
  Pending = "pending",
  Rejected = "rejected",
  Revoke = "revoke",
  Inactive = "Inactive",
}

export enum RequirementStageCodes {
  Proposal = "Proposal",
  CSLInitial = "CSL - Initial",
  SiteVisit = "Site Visit",
  CSLFinal = "CSL - Final",
  TermSheetSubmission = "Term Sheet Submission",
  FeeConfirmation = "Fee Confirmation",
  LetterofIntent = "Letter of Intent",
  Agreement = "Agreement",
  Invoice = "Invoice",

  PropertiesInDraftMode = "Properties in Draft Mode",
  LegalDueDiligence = "Legal Due Diligence",
  AgencyCommission = "Agency Commission",
}
